export default __webpack_public_path__ + "static/media/Empty.091ece01.gif";